import { InterventionNonPreventive } from '@/models/InterventionNonPreventive';
import { SortType } from '@/models/SortType';
import { TableHeader } from '@/models/TableHeader';
import { MutationTree } from 'vuex';
import { RapportASignerState } from './state';
import { RAPPORTS_A_SIGNER } from '@/modules/RapportASigner/store/mutation-types';

export const mutations: MutationTree<RapportASignerState> = {
    [RAPPORTS_A_SIGNER.SET_ITEMS](state, items: InterventionNonPreventive[]) {
        state.rapports = items;
    },
    [RAPPORTS_A_SIGNER.RESET_ITEMS](state) {
        state.rapports = [];
        state.page = 0;
        state.count = 0;
    },
    [RAPPORTS_A_SIGNER.ADD_ITEMS](state, items: InterventionNonPreventive[]) {
        state.rapports = [...state.rapports, ...items];
    },
    [RAPPORTS_A_SIGNER.SET_PAGE](state, page: number) {
        state.page = page;
    },
    [RAPPORTS_A_SIGNER.SET_NB_OF_PAGES](state, pages: number) {
        state.nbOfPages = pages;
    },
    [RAPPORTS_A_SIGNER.SET_COUNT](state, count: number) {
        state.count = count;
    },
    [RAPPORTS_A_SIGNER.SET_SCROLL](state, scroll: number) {
        state.scroll = scroll;
    },
    [RAPPORTS_A_SIGNER.SET_SORT](
        state,
        sort: {
            sortData: string;
            sortStatus: SortType;
        }
    ) {
        const tableHeader = state.tableHeader.reduce((newTable, headerItem) => {
            if (headerItem.sortData !== sort.sortData) {
                if (headerItem.sortStatus !== SortType.INACTIVE) headerItem.sortStatus = SortType.NONE;
            } else headerItem.sortStatus = sort.sortStatus;
            return [...newTable, headerItem];
        }, [] as TableHeader[]);
        state.tableHeader = tableHeader;
        state.sort = sort;
    },
    [RAPPORTS_A_SIGNER.ADD_FILTER_SITE](state, site: number) {
        state.filterSite = [...state.filterSite, site];
    },
    [RAPPORTS_A_SIGNER.SET_RAPPORT_A_SIGNER_SET_FILTER_SITE](state, siteList: Array<number>) {
        state.filterSite = siteList;
    },
    [RAPPORTS_A_SIGNER.RAPPORT_A_SIGNER_SET_FILTER_INTERVENTION_ID](state, id: string) {
        state.filterInterventionId = id;
    },
    [RAPPORTS_A_SIGNER.SUIVI_RAPPORT_A_SIGNER_SET_FILTER_PREDICTED_DATE_FROM](state, value: string) {
        state.filterPredictedDateFrom = value;
    },
    [RAPPORTS_A_SIGNER.SUIVI_RAPPORT_A_SIGNER_SET_FILTER_PREDICTED_DATE_TO](state, value: string) {
        state.filterPredictedDateTo = value;
    },
    [RAPPORTS_A_SIGNER.SET_RAPPORTS_A_SIGNER_IS_LOADING](state, isLoading: boolean) {
        state.isLoading = isLoading;
    },
    [RAPPORTS_A_SIGNER.SET_ERROR](state, error: Error | undefined) {
        state.error = error;
    },
    [RAPPORTS_A_SIGNER.SET_EXPORT_XLS_IS_LOADING](state, isLoading: boolean) {
        state.isExportXlsLoading = isLoading;
    },
};
